module.exports = __webpack_public_path__ + "static/media/Biotic.d4ebb4f5.svg";